export default function Logo({ compact = false }) {
  return (
    <span className="flex items-center gap-2.5">
      <svg width={compact ? 30 : 34} height={compact ? 30 : 34} viewBox="0 0 64 64" aria-hidden="true">
        <rect width="64" height="64" rx="15" fill="#00FF87" />
        <path d="M12 22h21M12 31.5h13" stroke="#050814" strokeWidth="5" strokeLinecap="round" />
        <path d="M45 9 24 37h12l-7 18 22-28H38l7-18z" fill="#050814" />
      </svg>
      <span className="leading-none">
        <span className="block font-display text-lg font-extrabold tracking-tight text-white">PayDay</span>
        <span className="block font-mono text-[9px] font-semibold uppercase tracking-[0.35em] text-pulse">India</span>
      </span>
    </span>
  );
}
